type TabContentProps = {
    isSelected: boolean;
    children: React.ReactNode;
};

const TabContent: React.FC<TabContentProps> = ({ isSelected, children }) => {
    return (
        <div
            
            className={`${isSelected ? "flex" : "hidden"} w-full h-full rounded-xl shadow-main overflow-hidden min-h-[50vh]`}
        >
            {children}
        </div>
    );
};

export default TabContent;
